"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _queryString = _interopRequireDefault(require("query-string"));

var _container = require("./container");

var Main = function Main(_ref) {
  var ehrRecord = _ref.ehrRecord,
      requestPatientRecord = _ref.requestPatientRecord,
      isNewRecordAvailable = _ref.isNewRecordAvailable,
      getPatientAttachment = _ref.getPatientAttachment,
      exportCDAAsPDF = _ref.exportCDAAsPDF,
      exportCDAAsPDFLoading = _ref.exportCDAAsPDFLoading,
      setExportCDAAsPDFLoading = _ref.setExportCDAAsPDFLoading;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isAttachment = _useState2[0],
      setIsAttachment = _useState2[1];

  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
      _useSearchParams2 = (0, _slicedToArray2.default)(_useSearchParams, 2),
      searchParams = _useSearchParams2[0],
      setSearchParams = _useSearchParams2[1];

  (0, _react.useEffect)(function () {
    var params = _queryString.default.parse(searchParams.toString());

    if (params.attachment) {
      setIsAttachment(true);
    } else {
      setIsAttachment(false);
    }
  }, [searchParams, setSearchParams]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isAttachment ? /*#__PURE__*/_react.default.createElement(_container.AttachmentViewer, {
    getPatientAttachment: getPatientAttachment
  }) : /*#__PURE__*/_react.default.createElement(_container.CDAMainViewer, {
    ehrRecord: ehrRecord,
    requestPatientRecord: requestPatientRecord,
    isNewRecordAvailable: isNewRecordAvailable,
    exportCDAAsPDF: exportCDAAsPDF,
    exportCDAAsPDFLoading: exportCDAAsPDFLoading,
    setExportCDAAsPDFLoading: setExportCDAAsPDFLoading
  }));
};

var _default = Main;
exports.default = _default;